import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { clearVerifyCache } from "../../services/authService";

axios.defaults.withCredentials = true;

const Logout = () => {
  const [auth, setAuth] = useState(false);
  const [message, setMessage] = useState("");
  const [reg,setReg]=useState('');
  const navigate = useNavigate();

    axios.defaults.withCredentials=true;

    useEffect(()=>{
      axios.get("/backend/logout")
      .then(res=>{
        const status = res.data.status || res.data.Status;
        if(status === "Success"){
          // clear any cached verification so protected routes re-check
          try{ clearVerifyCache(); }catch(e){}
          setAuth(true)
          setReg(res.data.reg_no || "")
          console.log(res)
          navigate("/")
        }
        else{
          setAuth(false)
          setMessage( res.data.Error || res.data.error || "Logout failed")
        }
      })
      .catch(err=>{
        console.log(err)
        setMessage("Logout request failed")
      })
    },[])
  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      {auth ?
            <div>
                <h3 style={{margin:'1900px'}}>u r authorized {reg}</h3>
                <button>Logout</button>
            </div>
            :
            <div>
                <h3>{message}</h3>
                <Link to="/login-page">Login </Link> 
            </div>}
    </div>
  );
};

export default Logout;
